import { Component, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StudyInstanceModel } from '../../../../shared/dataset/model/study-instance.model';

@Component({
    selector: 'jhi-choose-environment-modal',
    templateUrl: './single-environment-selector-modal.component.html'
})
export class SingleEnvironmentSelectorModalComponent implements OnDestroy {

    @Input() studyInstances: StudyInstanceModel[] = [];

    selectedInstanceId: number;
    datasetId: number;
    titleKey: string;
    descriptionKey: string;
    headerKey: string;
    cancelLabelKey: string;
    continueLabelKey: string;
    isSaving: false;
    continueBehavior: 'close_immediately' | 'persist' = 'persist';
    searchQuery: any;

    private confirmSubject = new Subject<number>();
    onContinue$ = this.confirmSubject.asObservable();

    constructor(
        public modalService: NgbModal,
        public activeModal: NgbActiveModal,
    ) {
    }

    ngOnDestroy(): void {
        this.confirmSubject.complete();
    }

    cancel() {
        this.activeModal.dismiss('back');
    }

    continue() {
        if (this.continueBehavior === 'close_immediately') {
            this.activeModal.close(this.selectedInstanceId);
        } else if (this.continueBehavior === 'persist') {
            this.confirmSubject.next(this.selectedInstanceId); // Emit confirm event with data
        }
    }
}

